import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// Add declaration for window.fbq
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

function useMetaPixel() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);
}

export default useMetaPixel;